import React, { useRef } from "react"
import { RenderError, SpecialZoomLevel, Viewer } from "@react-pdf-viewer/core"
import "@react-pdf-viewer/core/lib/styles/index.css"
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation"
import { toolbarPlugin } from "@react-pdf-viewer/toolbar"
import "@react-pdf-viewer/toolbar/lib/styles/index.css"
import { useTranslation } from "react-i18next"

import { customCanvasPlugin } from "./customCanvasPlugin"
import { FileViewerToolbar } from "./FileViewerToolbar"

export interface FileViewerProps {
    filePath: string
    isXmlEInvoice?: boolean
    showPaidStamp?: boolean
    RightSideToolbar?: React.ReactNode | null
    onUnsupportedFormatDownload?: () => void
    renderError?: RenderError
    pdfHeight?: number | "auto"
    enableSmoothScroll?: boolean
    defaultScale?: SpecialZoomLevel | number
    showToolbar?: boolean
}

export const FileViewer = React.memo(
    ({
        filePath,
        showPaidStamp = false,
        RightSideToolbar,
        renderError,
        onUnsupportedFormatDownload,
        isXmlEInvoice = false,
        pdfHeight = 900,
        enableSmoothScroll = false,
        defaultScale = 1,
        showToolbar = true,
    }: FileViewerProps) => {
        const { t } = useTranslation()

        const { current: pageNavigationPluginInstance } = useRef(pageNavigationPlugin())
        const toolbarPluginInstance = toolbarPlugin({})

        if (!filePath) {
            return null
        }

        return (
            <div
                style={{
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    height: pdfHeight,
                    width: "100%",
                }}
            >
                {showToolbar ? (
                    <FileViewerToolbar
                        isXmlEInvoice={isXmlEInvoice}
                        RightSideToolbar={RightSideToolbar}
                        onUnsupportedFormatDownload={onUnsupportedFormatDownload}
                        pageNavigationPluginInstance={pageNavigationPluginInstance}
                        toolbarPluginInstance={toolbarPluginInstance}
                    />
                ) : null}
                <div
                    style={{
                        flex: 1,
                        overflow: "hidden",
                    }}
                >
                    {/* https://github.com/react-pdf-viewer/react-pdf-viewer/issues/1076
                ugly hack to mitigate the re-rendering issue. TODO replace it after getting an answer from the library maintainer */}
                    <Viewer
                        fileUrl={showPaidStamp ? filePath : ` ${filePath}`}
                        plugins={[toolbarPluginInstance, pageNavigationPluginInstance, ...(showPaidStamp ? [customCanvasPlugin(t("label:paid"))] : [])]}
                        renderError={renderError}
                        enableSmoothScroll={enableSmoothScroll}
                        defaultScale={defaultScale}
                    />
                </div>
            </div>
        )
    },
)
